import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-organization",
  "use": "icon-organization-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-organization\"><defs><style type=\"text/css\"></style></defs><path d=\"M576 448v256h64V576h384v384h-384v-128H384v128H0V576h384v128h64V448H192V64h640v384H576z m-320 256H128v128h128v-128z m64-512v128h384V192H320z m448 512v128h128v-128h-128z\" p-id=\"3284\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol